import type { ProductVariantLineFragment } from '@/graphql/saleor/api';

import { parseCoordinates } from '../helpers';
import type { SizeType, StyleType } from '../types';

import * as S from '../EngravingModal.styles';

export interface EngravingImageProps {
  engravingValue: string;
  product: ProductVariantLineFragment['product'];
  sizeSelected: SizeType;
  styleSelected: StyleType;
}

const BASE_DIMENSION = 2048;

export const EngravingImage = ({
  engravingValue,
  product,
  sizeSelected,
  styleSelected,
}: EngravingImageProps) => {
  const backEngravingMedia = product.media?.find(
    (media) => media.backEngravingCoordinates !== null,
  );

  const coords = parseCoordinates(
    backEngravingMedia?.backEngravingCoordinates ?? null,
  );

  const hasText = Boolean(engravingValue && engravingValue.trim().length > 0);
  const showOverlay = Boolean(hasText && coords);

  const topPct = coords ? (coords.y1 / BASE_DIMENSION) * 100 : 0;
  const leftPct = coords ? (coords.x1 / BASE_DIMENSION) * 100 : 0;
  const widthPct = coords
    ? ((coords.x2 - coords.x1) / BASE_DIMENSION) * 100
    : 0;
  const heightPct = coords
    ? ((coords.y2 - coords.y1) / BASE_DIMENSION) * 100
    : 0;

  return (
    <S.WatchImageContainer>
      <S.WatchImage
        alt={product.name}
        height={343}
        src={backEngravingMedia?.url}
        width={343}
      />

      {showOverlay && (
        <S.EngravingOverlay
          $sizeSelected={sizeSelected}
          $styleSelected={styleSelected}
          style={{
            top: `${topPct}%`,
            left: `${leftPct}%`,
            width: `${widthPct}%`,
            height: `${heightPct}%`,
          }}
        >
          {engravingValue}
        </S.EngravingOverlay>
      )}
    </S.WatchImageContainer>
  );
};
